import { Navigate } from 'react-router-dom';
import { useTenant } from '../components/TenantContext.jsx';

/**
 * 母帳號 (role=admin) 專屬 route 守衛。
 * 子帳號 (agent/viewer) 即使 deep-link 也會被導回首頁 —— 用來擋住智慧客服（建客服）、
 * 租戶設定、成員管理、方案總覽、通訊錄、系統狀態等管理頁。
 * nav 隱藏只是 UX；這層才是真正擋住直接打 URL。
 */
export function RequireAdmin({ children }) {
    const { isAdmin, loading } = useTenant();
    if (loading) {
        return (
            <div className="grid min-h-dvh place-items-center text-ink-500">
                <div className="font-mono text-sm">Loading…</div>
            </div>
        );
    }
    if (!isAdmin) return <Navigate to="/" replace />;
    return children;
}
